/**
 * AppLayout — Shell de diseño para todas las pantallas de usuario autenticado.
 * Provee estructura consistente: contenido scrollable + bottom nav fija.
 * Respeta safe areas móviles y variables de viewport.
 */

import type { ReactNode } from 'react';
import { BottomNav } from './BottomNav';
import { cn } from '../../utils';
import { ActiveTrackingBadge } from '../tracking';
import { SystemToolsFabs } from '../location';
import { ProviderContextMenu } from '../providers';
import { FloatingActionDock, FloatingActionsProvider } from './floatingActions';

interface AppLayoutProps {
    children: ReactNode;
    /** Clases adicionales para el contenedor principal */
    className?: string;
    /** No aplicar padding bottom para el nav (ej. cuando el contenido hace su propio manejo) */
    noPadding?: boolean;
}

export function AppLayout({ children, className, noPadding = false }: AppLayoutProps) {
    return (
        <FloatingActionsProvider>
            <div className="flex min-h-dvh flex-col bg-background">
                <ProviderContextMenu />
                <div
                    className={cn(
                        'mx-auto flex w-full max-w-[600px] flex-1 min-h-0 flex-col',
                        !noPadding && 'pb-[calc(var(--bottom-nav-height)+var(--spacing-safe-bottom,0px))]',
                        className,
                    )}
                >
                    {children}
                </div>

                <ActiveTrackingBadge />
                <SystemToolsFabs />
                <FloatingActionDock />
                <BottomNav />
            </div>
        </FloatingActionsProvider>
    );
}
